import jsesc from "jsesc";
import { fetchApi } from "../../config/fetchConfig";

const searchStart = (q, projectId) => ({
    type: "SEARCH_TERM_START",
    payload: q,
});

const searchSuccess = (data, q, projectId) => ({
    type: "SEARCH_TERM_SUCCESS",
    payload: {
        data,
        q,
        projectId,
    },
});

let controller;
export const genericSearchAction =
    (q, location, projectId, fiscalYear, modulePrefix, importId) => (dispatch, getState) => {
        if (controller && controller.abort) {
            controller.abort();
        }
        const query = {
            query: `query ($q: String, $location: [String!], $projectId: String, $fiscalYear: String, $modulePrefix: String, $importId: String) {
					search_generic_entity(q: $q, location: $location, projectId: $projectId, fiscalYear: $fiscalYear, modulePrefix: $modulePrefix, importId: $importId) {
					__typename,
					id,
					name,
					entity
				}
			}`,
            variables: {
                q,
                location,
                projectId,
                fiscalYear,
                modulePrefix: modulePrefix,
                importId: importId,
            },
        };
        dispatch(searchStart(q, projectId));
        controller = new AbortController();
        const signal = controller.signal;
        return fetchApi("/graphql", query, { signal }, { dispatch, user: getState()?.user })
            .then((res) => res.json().catch(() => ({})))
            .then((res) => {
                const data = res.data || {};
                const searchData = data[`search_generic_entity`] || [];
                dispatch(searchSuccess(searchData, q, projectId));
            })
            .catch((e) => {
                console.log(jsesc(e));
            });
    };
